import { useLocalization } from '@/hooks/useLocalization';
import { useChat } from '@/hooks/useChat';
import { useWidget } from '@/state/WidgetContext';
import BotMessage from '@/components/ChatMessage/BotMessage';
import OptionButton from '@/components/OptionButton/OptionButton';
import ScreenOptions from '@/components/ScreenOptions/ScreenOptions';
import { SCREENS } from '@/utils/constants';
import styles from '@/styles/chat.module.scss';

const GlobeIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
  </svg>
);

export default function CatchupScreen() {
  const { t } = useLocalization();
  const { goTo } = useWidget();
  const { contactExpert } = useChat();

  return (
    <BotMessage text={t('catchup.message')}>
      <div className={styles.globe}><GlobeIcon /></div>
      <ScreenOptions>
        <OptionButton variant="primary" onClick={contactExpert}>
          {t('catchup.yesConsult')}
        </OptionButton>
        <OptionButton onClick={() => goTo(SCREENS.RESULTS)}>
          {t('catchup.browseSelf')}
        </OptionButton>
      </ScreenOptions>
    </BotMessage>
  );
}
